import React, { useEffect } from 'react';
import './transparencia.css';
import { transparencia_item } from '../../json/transparenciaItem';

const Transparencia = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Transparencia</h3>
                <hr className='hr-gob'/>
            </div>
        </div>
        <div className='row'>
            {
                transparencia_item.map((item, index)=>(
                    <div key={ index } className='col-md-12 col-sm-6 col-12'>
                        <div className='card_container_ligas'>
                            <div className='card_anio'>
                                <h5>{ item.anio }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.ligas.map((trim, index)=>(
                                        <h4>
                                            <div key={ index } className='card_liga'>
                                                <p>{ trim.transparencia_item_nombre } <span className="badge bg-secondary">
                                                    <a href={ trim.transparencia_item_url } target="_blank">Ver</a></span>
                                                </p> 
                                            </div>
                                        </h4>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }
                <div>
                
                <hr className='hr-gob'/>
            </div>
        </div>
    </div>        
  )
}

export default Transparencia